export default abstract class BaseProductSettings {
    overridable: boolean = false;
}